import { render, staticRenderFns } from "./RegionMap.vue?vue&type=template&id=da22e376&scoped=true"
import script from "./RegionMap.vue?vue&type=script&lang=js"
export * from "./RegionMap.vue?vue&type=script&lang=js"
import style0 from "./RegionMap.vue?vue&type=style&index=0&id=da22e376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da22e376",
  null
  
)

export default component.exports